import React, { useState } from "react";
import style from "./aboutme.module.css";
import myimg from "../images/Linkimg.jpg";

const Aboutme = () => {
  const [count, setcount] = useState(0);
  let arr = [
    [
      {
        id: 1,
        src: "https://1000logos.net/wp-content/uploads/2020/09/JavaScript-Logo.png",
        text: "JS",
      },
      {
        id: 2,
        src: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png",
        text: "React JS",
      },
      {
        id: 3,
        src: "https://icones.pro/wp-content/uploads/2021/05/icone-html-bleue.png",
        text: "HTML",
      },
      {
        id: 4,
        src: "https://www.freepnglogos.com/uploads/html5-logo-png/html5-logo-css-logo-png-transparent-svg-vector-bie-supply-9.png",
        text: "CSS",
      },
    ],
    [
      {
        id: 1,
        src: "https://brandlogos.net/wp-content/uploads/2021/09/bootstrap-logo.png",
        text: "Bootstrap",
      },
      {
        id: 2,
        src: "https://seeklogo.com/images/N/nodejs-logo-FBE122E377-seeklogo.com.png",
        text: "Node JS",
      },
      {
        id: 3,
        src: "https://cdn.icon-icons.com/icons2/2699/PNG/512/expressjs_logo_icon_169185.png",
        text: "Express",
      },
      {
        id: 4,
        src: "https://img.icons8.com/color/480/mongodb.png",
        text: "Mongo DB",
      },
    ],
    [
      {
        id: 1,
        src: "https://seeklogo.com/images/P/postman-logo-F43375A2EB-seeklogo.com.png",
        text: "PostMan",
      },
      {
        id: 2,
        src: "https://cdn4.iconfinder.com/data/icons/iconsimple-logotypes/512/github-512.png",
        text: "GitHub",
      },
      {
        id: 3,
        src: "https://cdn.icon-icons.com/icons2/2107/PNG/512/file_type_vscode_icon_130084.png",
        text: "VS Code",
      },
      {
        id: 4,
        src: "https://www.coffeeclass.io/logos/chakra-ui.png",
        text: "Chakra UI",
      },
    ],
  ];
  return (
    <div className={style.center}>
      <h1>ABOUT</h1>
      <div className={style.abtme}>
        <div className={style.pntfl}>
          <i className="fa-solid fa-cube"></i>
          <p>
            Completed my graduation in 2021 from{" "}
            <span className={style.coral}>
              Nitte Meenakshi Institute of Technology
            </span>
            , Bangalore
          </p>
        </div>
        <div className={style.pntfl}>
          <i className="fa-solid fa-cube"></i>
          <p>
            Joined{" "}
            <a href="https://www.masaischool.com/" className={style.coral} target="_blank">
              Masai School
            </a>{" "}
            on Jan 2022 in order to Learn Full Stack Web Development.
          </p>
        </div>
        <div className={style.pntfl}>
          <i className="fa-solid fa-cube"></i>
          <p>
            Hobbies include{" "}
            <span className={style.coral}>Playing Cricket</span>,{" "}
            <span className={style.coral}>Cooking</span> and{" "}
            <span className={style.coral}>Listening to Music</span>.
          </p>
        </div>
      </div>
      <div id="skills">
        <h1>
          PROFESSIONAL <span className={style.coral}>SKILLSET</span>
        </h1>
        <div className={style.mdivabt}>
          <p
            onClick={
              count > 0
                ? () => setcount(count - 1)
                : () => setcount(arr.length - 1)
            }
            className={style.arrow}
          >
            <i className="fa-solid fa-backward"></i>
          </p>
          <div className={style.abtfl}>
            {arr[count].map((elem) => (
              <div key={elem.id}>
                <img src={elem.src} alt="" />
                <h3 className={style.endal}>{elem.text}</h3>
              </div>
            ))}
          </div>
          <p
            onClick={
              count < arr.length - 1
                ? () => setcount(count + 1)
                : () => setcount(0)
            }
            className={style.arrow}
          >
            <i className="fa-solid fa-forward"></i>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Aboutme;
